import { useCallback } from 'react'

import copy from 'copy-to-clipboard'

import useNotification from './useNotification'

export default function useCopyToClipboard() {
  const notify = useNotification()

  return useCallback(
    (text: string) => {
      const copied = copy(text)

      if (copied) {
        notify('Copied to clipboard')
      } else {
        notify({
          type: 'error',
          message: 'Failed to copy to clipboard',
        })
      }
    },
    [notify]
  )
}
